// invoiceValidationSchema.ts

import { required, validateIBAN, validateOIB, isValidDecimal } from '../validator';
import { ValidationSchema } from '../validationForm';
import { Invoice } from '../../types/invoiceForm';

export const invoiceValidationSchema: ValidationSchema<Invoice> = {
  // iban: [validateIBAN],
  toOib: [validateOIB],
  fromOib: [validateOIB],
  taxRate: [isValidDecimal],
  discountRate: [isValidDecimal],
  
};
